import React from 'react'
import { useTranslation } from 'react-i18next'

import { FieldProps } from '../../../../../../../@types/types'
import { OtherFacilitiesScreenValidationResult } from '../../../../../../../@types/validation-types'
import TextInput from '../../../../../../common/inputs/textInput/TextInput'
import { getDefaultClasses } from '../../../../../../../utils/style-utils'

const PriceMultiplier: React.FC<FieldProps<OtherFacilitiesScreenValidationResult>> = ({
  screenName,
  insertionData,
  validationMessages,
  onChange,
  wrapperClassName = getDefaultClasses('full'),
}) => {
  const { t } = useTranslation()
  return (
    <div className={wrapperClassName}>
      <TextInput
        id='price-multiplier'
        propertyName='priceMultiplier'
        placeholder=''
        label={<span>{t('wizard.screen.otherFacilities.priceMultiplier', 'X multiplies the rent')}</span>}
        value={insertionData.priceMultiplier?.toString()}
        maxLength={4}
        type='text'
        affixRight='unit'
        errors={validationMessages!.priceMultiplier ?? []}
        doOnFieldChange={(property, value) => onChange({ screen: screenName, property }, value)}
      />
    </div>
  )
}
export default PriceMultiplier
